import { App } from '@capacitor/app';
import { isNativeApp } from './tracker';

/**
 * Sem este listener o Capacitor trata o botão "voltar" do Android por conta
 * própria e, na prática, fecha a app. Aqui passa a comportar-se como o "voltar"
 * do browser:
 *  1. se houver um modal/pop-up aberto, este fecha-se (ouve o evento 'app-back'
 *     e chama preventDefault());
 *  2. senão, volta uma página no histórico do router;
 *  3. na primeira página do histórico, minimiza a app (em vez de a fechar, para
 *     o turno/tracker não parecer terminado ao técnico).
 */
export function iniciarBotaoVoltar(router) {
  if (!isNativeApp()) return;

  App.addListener('backButton', () => {
    const evento = new CustomEvent('app-back', { cancelable: true });
    if (!window.dispatchEvent(evento)) return; // um modal tratou disto

    if (window.history.state?.back) {
      router.back();
    } else {
      App.minimizeApp();
    }
  });
}
